import { getDownloadURL, ref } from 'firebase/storage';
import { storage } from 'utils/firebase';

const resolvedUrlCache = new Map<string, string>();
const inFlightRequests = new Map<string, Promise<string>>();

export const resolveStorageUrl = (path: string): Promise<string> => {
  const cached = resolvedUrlCache.get(path);
  if (cached) return Promise.resolve(cached);

  const inFlight = inFlightRequests.get(path);
  if (inFlight) return inFlight;

  const storageRef = ref(storage, path);
  const promise = getDownloadURL(storageRef)
    .then((url) => {
      resolvedUrlCache.set(path, url);
      inFlightRequests.delete(path);
      return url;
    })
    .catch((err) => {
      inFlightRequests.delete(path);
      throw err;
    });

  inFlightRequests.set(path, promise);
  return promise;
};
